export const ROLES = [
  { value: 'ROLE_PERMISSAO_CRIAR_VENDA', label: 'Criar Venda' },
  { value: 'ROLE_PERMISSAO_CONFIGURAR_IA', label: 'Configurar a IA' },
  { value: 'ROLE_PERMISSAO_CRIAR_PROFISSIONAL', label: 'Criar profissional' },
  { value: 'ROLE_PERMISSAO_CANCELAR_VENDA', label: 'Cancelar venda' },
  { value: 'ROLE_PERMISSAO_INATIVAR_PROFISSIONAL', label: 'Inativar Profissional' },
  { value: 'ROLE_PERMISSAO_EDITAR_PROFISSIONAL', label: 'Editar Profissional' },
  { value: 'ROLE_PERMISSAO_VISUALIZAR_PERFIL_PUBLICO', label: 'Visualizar Perfil Público' },
  { value: 'ROLE_PERMISSAO_ALTERAR_QUANTIDADE_PROFISSIONAIS', label: 'Gerenciar a quantidade de profissionais da venda' }
];
